import { collectComponents } from '../utils/collectComponents.js';
import Accordion from './Accordion/index.js';
import AccordionButton from './Accordion/AccordionButton/index.js';
import AccordionContent from './Accordion/AccordionContent/index.js';
import AnchorTarget from './Anchor/AnchorTarget/index.js';
import Block from './Block/index.js';
import Carousel from './Carousel/index.js';
import Countdown from './Countdown/index.js';
import Coupon from './Coupon/index.js';
import Grid from './Grid/index.js';
import HTMLTemplate from './HTMLTemplate/index.js';
import Image from './Image/index.js';
import ImageMapBraze from './Image/ImageMapBraze/index.js';
import ImageMapLink from './Image/ImageMapLink/index.js';
import ImageMapShare from './Image/ImageMapShare/index.js';
import Link from './Link/index.js';
import Lottie from './Lottie/index.js';
import Page from './Page/index.js';
import ProductList from './ProductList/index.js';
import StickyTab from './StickyTab/index.js';
import StickyTabItem from './StickyTab/StickyTabItem/index.js';
import TextTabItem from './StickyTab/TextTabItem/index.js';
import Tab from './Tab/index.js';
import TabButton from './Tab/TabButton/index.js';
import TabContent from './Tab/TabContent/index.js';
import TabItem from './Tab/TabItem/index.js';
import Text from './Text/index.js';
import Video from './Video/index.js';

var defaultComponents = collectComponents([Page, Block, Grid, Text, Image, ImageMapLink, ImageMapShare, ImageMapBraze, Video, Link, Coupon, ProductList, Tab, TabItem, TabButton, TabContent, AnchorTarget, Carousel, Accordion, AccordionButton, AccordionContent, Lottie, Countdown, HTMLTemplate, StickyTab, StickyTabItem, TextTabItem]);

export { defaultComponents };
//# sourceMappingURL=defaultComponents.js.map
